import { FC, Fragment } from 'react';
import { Hint } from '@smart-kasa/ui';

import type { IReceiptItem } from 'types';
import { TAX_GROUP_MAPPING } from 'contants/taxGroup';
import { CLASSIFIER_TYPE_MAPPING } from 'contants/classifierType';
import { Currency } from 'components';

import { ReceiptRow } from './ReceiptRow';
import styles from './Receipt.module.scss';

export const ReceiptItem: FC<{ item: IReceiptItem }> = ({ item }) => {
  const taxGroup = !!item.taxGroupId && TAX_GROUP_MAPPING[item.taxGroupId];
  const classifierType = !!item.classifierTypeId && CLASSIFIER_TYPE_MAPPING[item.classifierTypeId];

  return (
    <ReceiptRow
      title={
        <Fragment>
          {item.name}
          <Hint margin={0}>{item.description}</Hint>
          {classifierType && (
            <Hint margin={0}>
              Код {classifierType.label}: {item.classifierCode}
            </Hint>
          )}
          {item.exciseLabel && <Hint margin={0}>Акцизна марка: {item.exciseLabel}</Hint>}
        </Fragment>
      }
      value={
        <Fragment>
          <Currency value={item.amount} /> {taxGroup && taxGroup.letter}
          <Hint margin={0}>
            {item.quantity}
            {item.unitTypeName} x <Currency value={item.price} />
          </Hint>
        </Fragment>
      }
      className={styles.item}
    />
  );
};
